
import { Component, Vue, Emit } from 'vue-property-decorator'
import { OderService, OrderDto, TransportDto,OrderDeliveryInput } from "@/api/service-proxies";
import { __param } from "tslib";
@Component
export default class DealDialog extends Vue {
    teackimg: any = []
    selectedValue = ""

    form = {
        name: '',
        number: ''
    }
    orderNumber: string
    oderService = new OderService();
    private dialogVisible: boolean = false
    isExporting = false
    public open(row) {
        this.orderNumber = row;
        this.dialogVisible = true,
            this.initTransporData();
    }
    close() {
        this.dialogVisible = false;
    }

    initTransporData() {
        this.oderService.getTransportList().then((result) => {

            this.teackimg = result;
        });
    }



    submit() {
    
      if(this.selectedValue==""){

        this.$alert("请选择快递公司","消息提示!");
        return;
      };
      if(this.form.number==""){
        this.$alert("快递单号不能为空","消息提示!");
        return;
      }
        const otherItems = this.teackimg.filter(item => item.companyCode == this.selectedValue);
            var input=new OrderDeliveryInput();
            input.orderNumer=this.orderNumber;
            input.companyCode=otherItems[0].companyCode;
            input.companyName=otherItems[0].name;
            input.companyNumber=this.form.number;
        this.oderService.setOrderDelivery(input);
        this.dialogVisible = false
}}

